export default {"src":"/assessments/student/_next/static/media/logo-phd.2074c45f.svg","height":32,"width":89,"blurWidth":0,"blurHeight":0};